export default {
    cardInfoTitle: 'Om kortet',

    cardLinkChangeCreditLimit: 'Endre kredittgrense',
    cardLinkCloseCreditAccount: 'Si opp kredittkortavtale',
    cardLinkCardDetails: 'Kortdetaljer',
    cardLinkTransaction: 'Se transaksjoner',
    cardLinkCustomerBenefits: 'Kundefordeler',
    cardLinkRegionBlock: 'Regionsperre og bruk',
    cardLinkCardControl: 'Brukstillatelser',
    cardLinkComplaint: 'Reklamasjon',
    cardLinkInsuranceProof: 'Forsikringsbevis',
    cardLinkInvoice: 'Faktura og dokumenter',
    cardLinkValueProgram: 'Verdiregnskap',
    cardLinkChangeDueDate: 'Endre forfallsdato',

    cardButtonExtraPayment: 'Ekstra innbetaling',
    cardDetailsHeader: 'Detaljer',
    cardSettingsHeaderOwner: 'Administrer kortet ditt',
    cardSettingsHeader: 'Administrer kortet',
    contactUs: 'Kontakt oss',

    cardOrderProgressOrdered: 'Kortet er bestilt',
    cardOrderProgressSentToProduction: 'Kortet produseres snart',
    cardOrderProgressProductionStarted: 'Kortet produseres',
    cardOrderProgressSentToCustomer: 'Kortet ditt er sendt',
    getCardDetailsError: 'Noe gikk galt ved henting av kortdetaljene.',

    googlePayText: 'Google Wallet',

    viewAndChange: 'Se og endre kortet ditt',
    cardInfo: 'Våre kredittkort leveres av Kredittbanken',

    cardLabelSoftBlocked: 'Midlertidig sperret',
    cardLabelBlocked: 'Sperret',
};
